var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmcc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#DD0632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7586 3.9375H9.85612L8.99325 5.42925L8.13319 3.9375H5.22956L2.25 9.09844L5.13506 14.0934L7.09088 10.7077L9 14.004L10.9035 10.7077L12.8638 14.1165L15.75 9.1215L12.7586 3.9375ZM5.13112 12.1185L3.38625 9.10012L4.77394 6.69712L6.51769 9.71775L5.13056 12.1213L5.13112 12.1185ZM5.34712 5.70488L5.80725 4.90556H7.54594L8.42063 6.42037L7.09088 8.72606L5.34712 5.70488ZM8.99213 12.0229L7.6635 9.7155L8.99325 7.41094L9.58725 8.4375L10.3241 9.71606L8.99325 12.0206L8.99213 12.0229ZM9.56419 6.42037L10.4406 4.90556H12.1793L12.645 5.70431L10.89 8.72606L9.56419 6.42037ZM14.0462 10.0974L12.8689 12.1399L11.4694 9.70987L13.2131 6.69544L13.6834 7.50544L14.6132 9.11587L14.0462 10.0974Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmcc);
export default __webpack_public_path__ + "static/media/xmcc.c8df87015d820d5027cc86f700273b76.svg";
export { ForwardRef as ReactComponent };